import { useQuery } from "@tanstack/react-query";
import { getMetaConfigs } from "../../api/bMetaApi";

export const useGetMetaConfigs = (organisationId) => {
  return useQuery({
    queryKey: ["meta-configs", organisationId],
    queryFn: () => getMetaConfigs(organisationId),
    enabled: !!organisationId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    onError: (error) => {
      console.error("Error fetching Meta configs:", error.response || error);
    },
  });
};
